/**
 * Create the store with dynamic reducers
 */

import { configureStore } from '@reduxjs/toolkit';
import { createMigrate, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import migrations from './migrations';
import reducer from './reducers';
const persistConfig = {
  key: 'root',
  version: 23,
  storage,
  whitelist: ['loan', 'profile', 'authentication'],
  migrate: createMigrate(migrations, { debug: false }),
};
const isDevToolsEnabled = process.env.REACT_APP_REDUX_DEV_TOOLS === 'true';
const persistedReducer = persistReducer(persistConfig, reducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
  ],
  devTools: isDevToolsEnabled,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
